<template>
  <Breadcrumbs
    title="Dealer Statement Report"
    :breadcrumbs="[
      { label: 'Report', path: '' },
      { label: 'Dealer Statement Report', path: '/dealer-statement' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <DealerStatementForm />
    </div>
  </div>
</template>

<script>
import DealerStatementForm from './dealerstatement_form.vue';

export default {
  name: 'DealerStatement',
  components: {
    DealerStatementForm,
  },
};
</script>

